import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

const specialProducts = [
  {
    id: 1,
    name: 'Royal Falooda',
    price: 120,
    image: 'https://images.unsplash.com/photo-1577968897966-3d4325b36b61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHx0ZWElMjBjdXB8ZW58MHx8fHwxNzcxMDY4NTIwfDA&ixlib=rb-4.1.0&q=85',
    veg: true,
    description: 'Creamy and delicious premium falooda'
  },
  {
    id: 2,
    name: 'Kiwi Shake',
    price: 80,
    image: 'https://images.unsplash.com/photo-1595434091143-b375ced5fe5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHx0ZWElMjBjdXB8ZW58MHx8fHwxNzcxMDY4NTIwfDA&ixlib=rb-4.1.0&q=85',
    veg: true,
    description: 'Refreshing kiwi milkshake'
  },
  {
    id: 3,
    name: 'Blue Curacao Mojito',
    price: 80,
    image: 'https://images.unsplash.com/photo-1653542772393-71ffa417b1c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2ppdG98ZW58MHx8fHwxNzcxMDY4NTI5fDA&ixlib=rb-4.1.0&q=85',
    veg: true,
    description: 'Cool blue refreshment'
  },
  {
    id: 4,
    name: 'Chicken Nuggets',
    price: 80,
    image: 'https://images.unsplash.com/photo-1562967914-608f82629710?w=800',
    veg: false,
    description: 'Crispy golden nuggets'
  }
];

export const SpecialProducts = () => {
  const handleWhatsAppOrder = (productName) => {
    const phoneNumber = '919994520043';
    const message = `Hi! I would like to order ${productName} from Insta Cafe.`;
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
    toast.success(`Opening WhatsApp to order ${productName}`);
  };

  return (
    <section className="section-padding">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Special Products
          </h2>
          <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto">
            Our signature items you can't miss
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {specialProducts.map((product) => (
            <div key={product.id} className="product-card group">
              {/* Image */}
              <div className="relative h-56 overflow-hidden rounded-t-xl">
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image w-full h-full object-cover"
                />
                {/* Special Badge */}
                <div className="absolute top-3 right-3 bg-secondary text-foreground px-3 py-1 rounded-full text-xs font-semibold">
                  SPECIAL
                </div>
                {/* Veg/Non-Veg */}
                <div className="absolute top-3 left-3">
                  {product.veg ? (
                    <div className="veg-indicator" />
                  ) : (
                    <div className="non-veg-indicator" />
                  )}
                </div>
              </div>

              {/* Content */}
              <div className="p-4 flex flex-col">
                <h3 className="font-semibold text-lg text-foreground mb-2">
                  {product.name}
                </h3>
                <p className="text-sm text-muted-foreground mb-4">
                  {product.description}
                </p>

                {/* Price & Action */}
                <div className="flex items-center justify-between mt-auto">
                  <span className="text-xl font-bold text-primary">
                    ₹{product.price}
                  </span>
                  <Button
                    size="sm"
                    className="btn-gold"
                    onClick={() => handleWhatsAppOrder(product.name)}
                  >
                    Order Now
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpecialProducts;